<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :show-timeout="200"
      :default-active="$route.name"
      :collapse="isCollapse"
      :background-color="variables.menuBg"
      :text-color="variables.menuText"
      :active-text-color="variables.menuActiveText"
      mode="vertical"
      unique-opened
    >
      <div class="logo__con">
        <span v-if="sidebar.opened">
          <!--                    <img src="@/static/img/logo.png" class="avatar"/>-->
          <span style="line-height: 100%">订单管理系统</span>
        </span>
        <span v-if="!sidebar.opened">
          <img src="@/static/img/logo_small.png" class="logo_small" />
        </span>
      </div>
      <div class="hamburger">
        <hamburger
          :toggle-click="toggleSideBar"
          :is-active="sidebar.opened"
          class="hamburger-container"
        />
      </div>
      <menu-item
        v-for="menu in menus"
        :key="menu.id"
        :item="menu"
        :base-path="menu.path"
      />
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from "vuex";
import MenuItem from "./MenuItem";
import variables from "@/styles/variables.scss";
import { appRouters } from "@/router/routes";
import userRoutes from "@/router/userRoutes";
import Hamburger from "@/components/Hamburger";
import { getUserInfo } from "@/utils/user";
import { find } from "lodash";

export default {
  components: { MenuItem, Hamburger },
  data() {
    return {
      menus: [],
    };
  },
  created() {
    this.$store
      .dispatch("permissionStore/listUserPermission", {
        request: JSON.stringify({ isGetCacheDta: false }),
      })
      .then((res) => {
        this.menus = res.items;
      });
  },
  computed: {
    ...mapGetters(["sidebar"]),
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    resetRouter(routers) {
      const userInfo = getUserInfo();
      const userId = userInfo.userId;
      const userRouterConfig = find(userRoutes, { userId });
      const router = userRouterConfig
        ? this.checkRouterPermission(appRouters, userRouterConfig.disableRouter)
        : routers;
      return router;
    },
    checkRouterPermission(routers, disableRoutes) {
      return routers.filter((item) => {
        if (item.children) {
          item.children = this.checkRouterPermission(
            item.children,
            disableRoutes
          );
        }
        return !disableRoutes.includes(item.name);
      });
    },
  },
};
</script>

<style lang="scss">
.scrollbar-wrapper {
  .hamburger {
    margin-top: 24px;
  }

  .logo__con {
    height: 64px;
    line-height: 64px;
    padding: 10px;
    color: #fff;
    font-size: 16px;
    text-align: center;

    img {
      height: 50px;
    }

    .logo_small {
      height: 32px;
    }
  }
}
</style>
